import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartData, ChartZoom, HistTokenData } from './types';
import { RootState, AppThunk } from '../';
import { findDates } from "./chartDates";
import { sortData } from "./sortData";


export interface ChartState {
  zoom: string;
  dates: string[];
  data: ChartData;
  dayData: ChartData;
  changes: number[];
  pnl: number[];
  histData: HistTokenData[];
  chartZoom: ChartZoom;
}

const initialState: ChartState = {
    zoom: "week",
    dates: [],
    data: {} as ChartData,
    dayData: {} as ChartData,
    changes: [],
    pnl: [],
    histData: [],
    chartZoom: {
      portLine: "week",
      worthLine: "week",
      dailyBar: "week",
      dailyLine: "week"
    },
};

export const chartSlice = createSlice({
    name: 'chart',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
      setZoom: (state: { zoom: string; }, action: PayloadAction<string>) => {
        state.zoom = action.payload;
      },
      setDates: (state: { dates: string[]}, action: PayloadAction<string>) => {
        state.dates = findDates(action.payload);
      },
      setData: (state: { data: ChartData}, action: PayloadAction<ChartData>) => {
        state.data = action.payload;
      },
      setDayData: (state: { dayData: ChartData}, action: PayloadAction<ChartData>) => {
        state.dayData = action.payload;
      },
      setChanges: (state: { changes: number[]}, action: PayloadAction<number[]>) => {
        state.changes = action.payload;
      },
      setPnl: (state: { pnl: number[]}, action: PayloadAction<number[]>) => {
        state.pnl = action.payload;
      },
      setHistData: (state: { histData: HistTokenData[]}, action: PayloadAction<HistTokenData[]>) => {
        state.histData = action.payload;
      },
      setChartZoom: (state: { chartZoom: ChartZoom}, action: PayloadAction<ChartZoom>) => {
        state.chartZoom = action.payload;
      },
    },
});

export const { 
  setZoom, 
  setDates, 
  setData, 
  setChanges, 
  setPnl,
  setHistData,
  setChartZoom,
  setDayData,
 } = chartSlice.actions;

export const selectZoom = (state: RootState) => state.chart.zoom;
export const selectDates = (state: RootState) => state.chart.dates;
export const selectData = (state: RootState) => state.chart.data;
export const selextDayData = (state: RootState) => state.chart.dayData;
export const selectChanges = (state: RootState) => state.chart.changes;
export const selectPnl = (state: RootState) => state.chart.pnl;
export const selectHistData = (state: RootState) => state.chart.histData;
export const selectChartZoom = (state: RootState) => state.chart.chartZoom;

export default chartSlice.reducer;